import { NeedDto } from '@act/shared/data-transfer-objects';
import { Button } from '@act/storybook';
import syvaNeedsUtils from 'react-components/needs/syva-needs-utils';
import { needRequests } from 'redux/requests/need.requests';
import { membersAppSelectors } from 'redux/slices/memberSlice';
import { useApiCall } from 'redux/utils/api-hook';
import StyledAlert from 'toolkit/alerts/styled-alert';

const NeedTimeAlert = ({
  need,
  showDaysRemaining = true,
}: {
  need: NeedDto;
  showDaysRemaining?: boolean;
}) => {
  const [_payload, _isLoading, patchNeed] = useApiCall(needRequests.patchNeed);
  const member = membersAppSelectors.useSelectMemberById(need.memberId);
  function extendTime() {
    patchNeed({
      body: { shouldExtend: true },
      params: { needId: need?.id },
    });
  }

  const daysRemaining = syvaNeedsUtils.calculateRemainingDays(need.expiresAt);
  const canExtendTime = daysRemaining < 7;
  const needEditable = syvaNeedsUtils.needIsEditable(need, member);

  if (!needEditable || !!need.fulfilledAt) {
    return null;
  }

  if (canExtendTime) {
    return (
      <StyledAlert
        severity="warning"
        variant="tonal"
        message={`Only ${daysRemaining} days remaining in time window`}
        actions={[
          <Button
            key="extend-time"
            debounced
            variant="text"
            trackingName="need-extend-time-alert-button-submit"
            onClick={() => extendTime()}
            sx={{
              color: 'primary',
              alignSelf: 'center',
            }}
          >
            Extend time
          </Button>,
        ]}
      />
    );
  } else {
    if (showDaysRemaining) {
      return (
        <StyledAlert
          message={`${daysRemaining} days remaining in time window`}
          severity="info"
        />
      );
    }
  }
};

export default NeedTimeAlert;
